import FormDialog from "../../../components/dialog/form/FormDialog.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
import { SnackBarModule } from "../../../modules/SnackBarModule";
import {
  AtosBoletimService
} from "../../../services/AtosBoletimService";

export default {
  name: "EditarLegislacao",

  components: {
    FormDialog,
    TextField,
  },

  props: {
    isOpen: {
      required: true

    }

  },

  data: () => ({
    id: "",
    form: {},
    loading: {
      button: false
    }
  }),

  beforeMount() {
    this.initializeForm();
    this.pegarLegislacao();

  },
  watch: {
    isOpen: function (isOpen) {
      if (isOpen) {
        this.initializeForm();
        this.pegarLegislacao();
      }
    },
  },


  methods: {
    initializeForm() {
      this.form = {
        
        nome: null,
      };
    },

    prepareForm() {
      if (this.form.nome != null) {

        const form = new FormData();
        form.append('nome', this.form.nome);

        return this.sendForm(form);
      }
      SnackBarModule('Preencha todos os campos', 'error')
    },

    async pegarLegislacao(){
      const response = await AtosBoletimService.pegarLegislacao();
      this.form.nome = response.nome;
      this.id = response.id;
    },

    async sendForm(formData) {
      this.loading.btn = true;
      const response = await AtosBoletimService.editarLegislacao(formData, this.id);
      this.loading.btn = false;
      if (response) {
        this.initializeForm();
        this.close();
      }
      this.loading.btn = false;
    },

    close() {
      this.$emit("on-close");
      this.initializeForm();

    },

  },
};
1